import { render, staticRenderFns } from "./GeneratedRules.vue?vue&type=template&id=2e2898c7&scoped=true&"
import script from "./GeneratedRules.vue?vue&type=script&lang=js&"
export * from "./GeneratedRules.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedRules.vue?vue&type=style&index=0&id=2e2898c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2898c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VCol,VContainer,VRadio,VRadioGroup})
